//@ts-check
import * as d3 from "d3";

/**
* Add a label to single element
* @param {any} group_ID Pass the element id from the loaded drawing in 2D Viewer
* @param {string} value Pass the label for single element
* @returns {Object} It returns an object for acknowledgement of this API to the consumer side.
*/
export function labelElement(group_ID, value) {
  try {
    let scope = this;
    let groupID = [], values = [];
    groupID.push(group_ID);
    values.push(value);
    scope.labelElements(groupID, values);
    var returnValue = {
      'status': 'success',
      'message': 'Label element API'
    }
    return returnValue;
  }
  catch (err) {
    var returnValue = {
      'status': 'failed',
      'message': "System Error: " + err.message
    }
    return returnValue;
  }
}

/**
 * Add multiple labels to the multiple elements
 * @param {any[]} group_IDs Pass the array of group id from the loaded drawing in 2D Viewer
 * @param {Array<string>} values Pass the array of labels for multiple elements
 * @returns {Object} It returns an object for acknowledgement of this API to the consumer side.
 */
export function labelElements(group_IDs, values) {

  try {
    let scope = this;
    var x, y, object, svgObject;
    if (scope.content._groups && scope.content._groups.length != 0) {
      scope.clearAllLabels();

      let fontSize = Math.max(scope.boundary.width, scope.boundary.height) * scope.textScale * scope.labelSize;

      for (let i = 0; i < group_IDs.length; i++) {
        scope.label_Ids.push(group_IDs[i]);
        scope.labelVariables.push(values[i]);
        scope.content.selectAll('#' + group_IDs[i]).each(function () {

          let label = scope.overlay.append('g');
          label.attr('id', group_IDs[i]);
          scope.setDefaultGroup(label);
          label.attr('data-isLbl', true);

          object = d3.select(this).node().getBBox();
          x = object.x + object.width / 2;
          y = object.y + object.height / 2;

          scope.labelStyle(label, values[i], x, y, fontSize);

        });

      }
      var returnValue = {
        'status': 'success',
        'message': 'Label elements API'
      }
      return returnValue;
    }
    else {
      var returnValue = {
        'status': 'failed',
        'message': 'ERROR : Either drawing is not loaded in viewer or element id array and label array is not same.'
      }
      return returnValue;
    }
  }
  catch (err) {
    var returnValue = {
      'status': 'failed',
      'message': "System Error :" + err.message
    }
    return returnValue;
  }
}


/**
 * Style Label
 * @param {*} element 
 * @param {*} contents 
 * @param {*} x 
 * @param {*} y 
 * @param {Number} fontSize 
 */
export function labelStyle(element, contents, x, y, fontSize) {
  let scope = this;

  let elem = element.append('text')
    .text(scope.setDigits(contents))
    .style('font-size', fontSize.toString() + 'px')
    .attr('fill', scope.textColor)
    .attr('font-weight', '300')
    .attr('x', x)
    .attr('y', y)
    .attr('text-anchor', 'middle')
    .attr('dominant-baseline', 'middle')
    .attr('data-isStroke', false)
    .attr('data-isFill', false);

  let border = fontSize / 2.0;
  let textBorder = elem.node().getBBox();

  let boundary = element.append('rect')
    .style('stroke', 'white')
    .style('stroke-width', border / 10)
    .style('fill', scope.labelFillColor)
    .style('opacity', 0.75)
    .attr('x', textBorder.x - border)
    .attr('y', textBorder.y - border / 4)
    .attr('width', textBorder.width + border * 2)
    .attr('height', textBorder.height + border / 2)
    .attr('rx', border * 1.5)
    .attr('ry', border * 1.5)
    .attr('data-isStroke', false)
    .attr('data-isFill', true);

  elem.node().parentNode.insertBefore(boundary.node(), elem.node());
}


/**
 * Update all the label size
 * @param {Number} labelSize 
 * @returns {Object}
 */
export function updateAllLabels(labelSize) {
  let scope = this;
  try {
    if (labelSize > 0) scope.labelSize = labelSize;
    let ids = scope.label_Ids.map((x) => x);
    let lbl = scope.labelVariables.map((x) => x);

    scope.labelElements(ids, lbl);
  }
  catch (err) {
    var returnValue = {
      'status': 'failed',
      'message': "System Error: " + err.message
    }
    return returnValue;
  }
}

/**
 * Remove a label from a single element
 * @param {any} group_ID Pass the group id from the loaded drawing in 2D viewer
 * @returns {Object} Return success or error messages 
 */
export function removeLabel(group_ID) {
  let scope = this;
  try {
    if (scope.overlay._groups && scope.overlay._groups.length != 0) {
      let group = scope.overlay.selectAll('#' + group_ID);
      group.remove();

      var returnValue = {
        'status': 'success',
        'message': 'Label removed ' + group_ID
      }
      return returnValue;
    }
  }
  catch (err) {
    var returnValue = {
      'status': 'failed',
      'message': "System Error : " + err.message
    }
    return returnValue;
  }
}

/**
 * Remove multiple labels from the multiple elements
 * @param {Array<string>} group_IDs Pass the array of element id from the loaded drawing in 2D Viewer
 * @returns {Object} Return success or error messages 
 */
export function removeLabels(group_IDs) {
  try {
    let scope = this;
    if (scope.canvas.children.length != 0) {
      for (let i = 0; i < group_IDs.length; i++) {

        let group = scope.overlay.selectAll('#' + group_IDs);
        group.remove();

      }
      var returnValue = {
        'status': 'success',
        'message': 'Removed labels API'
      }
      return returnValue;
    }
  }
  catch (err) {
    var returnValue = {
      'status': 'failed',
      'message': "System Error : " + err.message
    }
    return returnValue;
  }
}

/**
 * 
 * @returns {Object} Return success or error messages 
 */
export function clearAllLabels() {
  let scope = this;
  try {
    if (scope.overlay._groups && scope.overlay._groups.length != 0) {

      scope.overlay.selectAll("*").remove();
      scope.label_Ids = [];
      scope.labelVariables = [];

      var returnValue = {
        'status': 'success',
        'message': 'Clear all labels API'
      }
      return returnValue;
    }
    else {
      var returnValue = {
        'status': 'failed',
        'message': 'ERROR : Drawing is not loaded in viewer.'
      }
      return returnValue;
    }
  }
  catch (err) {
    var returnValue = {
      'status': 'failed',
      'message': "System Error : " + err.message
    }
    return returnValue;
  }
}